<script setup lang="ts">
import { computed } from 'vue';
import i18n from '@/i18n';
import { every, isEmpty } from 'lodash';
import { LANG_ENGLISH } from '@/constants';
import { useComponentComposable } from '@/components/useComponentComposable';
import Carousel from 'primevue/carousel';
import SidePromoCard from './SidePromoCard.vue';

interface Props {
  value: any[];
  section: any;
}
const props = defineProps<Props>();

const { renderHTMLContent } = useComponentComposable();
const currentLanguage = i18n.global.locale.value;

const products = computed(() => {
  const payload = [...props.value];
  return payload.filter((p) => {
    return !every(p, isEmpty);
  });
});

const sectionTitle = computed(() => {
  return (currentLanguage === LANG_ENGLISH ? props.section.sidePromoTitleEn : props.section.sidePromoTitleFr) || '';
});
</script>

<template>
  <div class="side-bar-promo">
    <div class="p-0 mt-5">
      <Carousel :value="products" :numVisible="1" :numScroll="1" orientation="vertical" verticalViewPortHeight="460px" class="kr max-w-400px">
        <template #header>
          <renderHTMLContent :data="sectionTitle" htmlElement="h2"></renderHTMLContent>
        </template>
        <template #item="slotProps">
          <SidePromoCard :products="slotProps.data" />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep() {
  .product-item {
    ul {
      list-style: disc;

      li::marker {
        color: $col-red;
        background-color: $col-red;
      }
    }
  }
}

.kr :deep(.tAndC) {
  display: block;
  text-decoration: underline;
  margin-top: 20px;
  color: $col-black !important;
}

.kr :deep(.p-carousel-indicators) {
  .p-carousel-indicator.p-highlight .p-link {
    background: $col-redlgt;
  }
}

:deep(.p-dialog-header, .p-dialog-content) {
  background: transparent;
}

:deep(.product-item-content ul) {
  padding: revert !important;
}
</style>
